import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'isToday',
  standalone: false,
})
export class DateIsTodayPipe implements PipeTransform {
  public transform(value: moment.Moment | Date | string): boolean {
    const midnight = moment().endOf('day').utc();
    const utc = moment.isMoment(value) ? value.endOf('day').utc() : moment(value).endOf('day').utc();

    return midnight.diff(utc, 'hours') === 0;
  }
}
